import GenericRequest, { METHOD_POST } from '../../../webservices/GenericRequest';
import { ApiEndpoints } from '../../../webservices/endpoint';

export class DocumentSearchTask extends GenericRequest {

    _request; // DocumentSearchRequest

    constructor(request) {
        super(METHOD_POST, ApiEndpoints.DOCUMENTS);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/document/list/document-search/DocumentSearchTask.js